import type { PropertyDocumentKind } from '@/shared/api';
import { downscalePortalPhoto } from '@/shared/lib/downscaleImage';

/**
 * Welche Fotos vor dem Hochladen verkleinert werden — und welche ausdrücklich nicht.
 *
 * **Verkleinert** wird, was angeschaut wird: Marketing-, Zustands- und Inventarfotos landen im
 * Betrachter, und dort sieht niemand mehr als 2560 px.
 *
 * **Unangetastet** bleibt, was beweisen soll. Ein Schadensfoto ist kein Bild, sondern ein Beleg:
 * Auflösung und EXIF (Aufnahmezeit, Gerät, ggf. Ort) sind der halbe Wert. Wer es verkleinert,
 * wirft genau das weg, wofür es aufgenommen wurde — und merkt es erst im Streitfall.
 *
 * **Belege bleiben ebenfalls unangetastet.** Eine abfotografierte Rechnung ist ein Dokument;
 * Lesbarkeit schlägt Dateigröße.
 */
const DOWNSCALED_KINDS: readonly PropertyDocumentKind[] = [
  'FotoMarketing',
  'FotoZustand',
  'FotoInventar',
];

export function shouldDownscale(kind: PropertyDocumentKind): boolean {
  return DOWNSCALED_KINDS.includes(kind);
}

/** Gibt die Datei zurück, die tatsächlich hochgeladen werden soll. */
export function prepareForUpload(file: File, kind: PropertyDocumentKind): Promise<File> {
  return shouldDownscale(kind) ? downscalePortalPhoto(file) : Promise.resolve(file);
}
